module.exports = __webpack_public_path__ + "img/icon-enterprise-white.754e4630.svg";